import { render, staticRenderFns } from "./QuickBrandContainer.vue?vue&type=template&id=214c6f13&"
import script from "./QuickBrandContainer.vue?vue&type=script&lang=js&"
export * from "./QuickBrandContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports